import { jsx } from "react/jsx-runtime";
import { d as useToggletip, T as ToggletipContext } from "../../../../chunks/useToggletip-C_JZsx5D.js";
function ToggletipContainer({ children, className, ...props }) {
  const toggletip = useToggletip({ ...props });
  return /* @__PURE__ */ jsx(ToggletipContext.Provider, { value: toggletip, children: /* @__PURE__ */ jsx("div", { className, children }) });
}
export {
  ToggletipContainer
};
